import React from 'react';
import { Checkbox } from 'antd';

export const CheckBoxCell = ({ value }: any) => {
  return <Checkbox checked={value} />;
};
